import { render, staticRenderFns } from "./MemberInviteFriends.vue?vue&type=template&id=a74314f0&"
import script from "./MemberInviteFriends.vue?vue&type=script&lang=js&"
export * from "./MemberInviteFriends.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports